module.exports = __webpack_public_path__ + "static/media/us.fab2efbf.svg";